import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatBotApi } from 'src/app/_shared/api/chat-bot.api';
import { ProspektrApi } from '../_shared/api/prospektr.api';
// import { ChatBotState } from './chat-bot.state';

@Injectable({
  providedIn: 'root',
})
export class ChatBotService {
  constructor(
    private chatBotApi: ChatBotApi,
    private prospektrApi: ProspektrApi,

  ) { }

  sendMessage(params): Observable<{ isLoading?: boolean; data?: any, message?: string }> {
    return new Observable((observer) => {
      observer.next({ isLoading: true });

      this.chatBotApi.chatApi(params).subscribe(
        (res: any) => {
          observer.next({ isLoading: false, data: res?.data });
          observer.complete();
        },
        (err) => {
          observer.next({ isLoading: false, data: null, message: err?.error?.message });
          observer.complete();
        }
      );
    });
  }

  checkUserDetails(): Observable<{ isLoading?: boolean; data?: any }> {
    return new Observable((observer) => {
      observer.next({ isLoading: true });

      this.prospektrApi.checkUserDetails().subscribe(
        (res: any) => {
          observer.next({ isLoading: false, data: res?.data });
          observer.complete();
        },
        (err) => {
          observer.next({ isLoading: false, data: null });
          observer.complete();
        }
      );
    });
  }

}
